import { createFileRoute } from "@tanstack/react-router"
import { OrganizationIntegrationsPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/organization-settings/integrations"
)({
  component: () => (
    <AuthorizationGate resource={Resource.ORGANIZATION} action={Action.MANAGE}>
      <OrganizationIntegrationsPage />
    </AuthorizationGate>
  ),
})
